(function($, window, undefined) {
    function appendReturn() {
        $('#returnContainer').html('');

        var counter;
        var returnLength = window.order.returnProducts.length;
        var yearCounter;
        var year;
        var yearOptions;
        var product;
        var id;
        var uploadBtn;

        for (counter = 0; counter < returnLength; counter++) {
            yearOptions = '';
            product = window.order.returnProducts[counter].product;

            id = product.id;

            uploadBtn = '<label for="userPhoto_' + id + '_' + counter + '" class="file-selector"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17"><path d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"></path></svg> <span>Choose a file...</span></label>';

            for (yearCounter = -2; yearCounter < 1; yearCounter++) {
                year = (new Date()).getFullYear() + yearCounter;
                yearOptions += '<option value="' + year + '">' + year + '</option>';
            }

            $('#returnContainer').append(
                '<li id="return_item_' + id + '_' + counter + '" class="list-group-item">' +
                    '<div class="row">' +
                        '<div class="col-xs-12">' +
                            '<div class="col-sm-3 col-xs-12">' +
                                '<div class="item-preview">' +
                                    '<img src="' + product.image.src + '" width="80px" alt="" />' +
                                    '<span class="item-name">' + product.name + '</span>' +
                                '</div>' +
                            '</div>' +

                            '<div class="col-sm-3 col-xs-12">' +
                                '<div class="form-group">' +
                                    '<label>* Motivo de la devolución:</label>' +
                                    '<select class="form-control" name="reason_item_' + id + '_' + counter + '" id="sel1">' +
                                        '<option value="">Escoja un motivo</option>' +
              							'<option value="Exchange for another item">Cambio por otro artículo</option>' +
                                        //'<option value="Size Don\'t Fit Well">La talla no se ajusta bien</option>' +
                                        '<option value="Wrong Product Received or Wrong Size">Se han confundido con mi color</option>' +
                                        '<option value="Not as Described Item">El artículo no es como se ha descrito</option>' +
                                        '<option value="Defective Product Received">Producto defectuoso recibido</option>' +
                                    '</select>' +
                                '</div>' +
                                '<span class="error returnReasonError" style="display:none;" id="reason_error_' + id + '_' + counter + '"><i class="fa fa-times"></i><span class="errormessage">Debe seleccionar un motivo.</span></span>' +

                            '</div>' +

                            '<div class="col-sm-3 col-xs-12">' +
                                '<div class="form-group">' +
                                    '<label><span class="fn-requiredOptional"></span> Subir una foto:</label>' +
                                    '<div class="clear"></div>' +
                                    '<input type="file" name="file_item_' + id + '_' + counter + '" id="userPhoto_' + id + '_' + counter + '" class="inputfile inputfile-2">' +
                                    uploadBtn +
                                '</div>' +
                                '<span class="error returnPhotoError" style="display:none;" id="photo_error_' + id + '_' + counter + '"><i class="fa fa-times"></i><span class="errormessage">Debe subir una foto del producto.</span></span>' +
                            '</div>' +

                            '<div class="col-sm-3 col-xs-12">' +
                                '<div class="form-group">' +
                                    '<label>* Describa el Motivo:</label>' +
                                    '<textarea class="form-control" placeholder="Ayúdenos a mejorar proporcionando todos los detalles que pueda. ¡Gracias!" name="extra_item_' + id + '_' + counter + '"></textarea>' +
                                '</div>' +
                                '<span class="error returnDescribeReasonError" style="display:none;" id="extra_error_' + id + '_' + counter + '"><i class="fa fa-times"></i><span class="errormessage">Debe describir el motivo.</span></span>' +
                            '</div>' +

                            '<div class="col-lg-6 col-md-3 col-sm-4 col-xs-12">' +
                                '<label class="no-margin">* Fecha de recepción del producto:</label>' +
                                '<div class="form-group date clearfix">' +
                                    '<select class="form-control date-form date-form-year" name="year_item_' + id + '_' + counter + '">' +
                                        '<option value="">Año</option>' +
                                        yearOptions +
                                    '</select>' +

                                    '<select class="form-control date-form date-form-month" name="month_item_' + id + '_' + counter + '">' +
                                        '<option value="">Mes</option>' +
                                        '<option value="01">Enero</option>' +
                                        '<option value="02">Febrero</option>' +
                                        '<option value="03">Marzo</option>' +
                                        '<option value="04">Abril</option>' +
                                        '<option value="05">Mayo</option>' +
                                        '<option value="06">Junio</option>' +
                                        '<option value="07">Julio</option>' +
                                        '<option value="08">Agosto</option>' +
                                        '<option value="09">Septiembre</option>' +
                                        '<option value="10">Octubre</option>' +
                                        '<option value="11">Noviembre</option>' +
                                        '<option value="12">Deciembre</option>' +
                                    '</select>' +

                                    '<select class="form-control date-form date-form-day" name="day_item_' + id + '_' + counter + '">' +
                                        '<option value="">Día</option>' +
                                        '<option value="01">1</option>' +
                                        '<option value="02">2</option>' +
                                        '<option value="03">3</option>' +
                                        '<option value="04">4</option>' +
                                        '<option value="05">5</option>' +
                                        '<option value="06">6</option>' +
                                        '<option value="07">7</option>' +
                                        '<option value="08">8</option>' +
                                        '<option value="09">9</option>' +
                                        '<option value="10">10</option>' +
                                        '<option value="11">11</option>' +
                                        '<option value="12">12</option>' +
                                        '<option value="13">13</option>' +
                                        '<option value="14">14</option>' +
                                        '<option value="15">15</option>' +
                                        '<option value="16">16</option>' +
                                        '<option value="17">17</option>' +
                                        '<option value="18">18</option>' +
                                        '<option value="19">19</option>' +
                                        '<option value="20">20</option>' +
                                        '<option value="21">21</option>' +
                                        '<option value="22">22</option>' +
                                        '<option value="23">23</option>' +
                                        '<option value="24">24</option>' +
                                        '<option value="25">25</option>' +
                                        '<option value="26">26</option>' +
                                        '<option value="27">27</option>' +
                                        '<option value="28">28</option>' +
                                        '<option value="29">29</option>' +
                                        '<option value="30">30</option>' +
                                        '<option value="31">31</option>' +
                                    '</select>' +
                                '</div>' +
                                '<span class="error returnDateError" style="display:none;" id="date_error_' + id + '_' + counter + '"><i class="fa fa-times"></i><span class="errormessage">Debe elegir una fecha válida.</span></span>' +
                            '</div>' +

                            '<div class="col-lg-3 col-md-6 col-sm-5 col-xs-12">' +
                                '<label class="no-margin">* Valore la calidad del producto:</label>' +

                                '<div class="rate-items-wrapper">' +

                                    '<div class="rating-items-inputs">' +
                                        '<input type="radio" id="rate_item_' + id + '_' + counter + '_5" name="rate_item_' + id + '_' + counter + '" value="5"/>' +
                                        '<label for="rate_item_' + id + '_' + counter + '_5">5</label>' +

                                        '<input type="radio" id="rate_item_' + id + '_' + counter + '_4" name="rate_item_' + id + '_' + counter + '" value="4"/>' +
                                        '<label for="rate_item_' + id + '_' + counter + '_4">4</label>' +

                                        '<input type="radio" id="rate_item_' + id + '_' + counter + '_3" name="rate_item_' + id + '_' + counter + '" value="3"/>' +
                                        '<label for="rate_item_' + id + '_' + counter + '_3">3</label>' +

                                        '<input type="radio" id="rate_item_' + id + '_' + counter + '_2" name="rate_item_' + id + '_' + counter + '" value="2"/>' +
                                        '<label for="rate_item_' + id + '_' + counter + '_2">2</label>' +

                                        '<input type="radio" id="rate_item_' + id + '_' + counter + '_1" name="rate_item_' + id + '_' + counter + '" value="1"/>' +
                                        '<label for="rate_item_' + id + '_' + counter + '_1">1</label>' +

                                        '<input type="radio" id="rate_item_' + id + '_' + counter + '_0" name="rate_item_' + id + '_' + counter + '" value="0"/>' +
                                        '<label for="rate_item_' + id + '_' + counter + '_0">0</label>' +

                                        '<div class="clear"></div>' +

                                    '</div>' +

                                    '<hr class="ruler"/>' +

                                    '<div class="rating-measure">' +
                                        '<span class="">POBRE</span>' +
                                        '<span class="">BUENA</span>' +
                                        '<span class="">EXCELENTE</span>' +
                                    '</div>' +
                                    '<span class="error returnRateError" style="display:none;" id="rate_error_' + id + '_' + counter + '"><i class="fa fa-times"></i><span class="errormessage">Necesitamos su valoración.</span></span>' +
                                '</div>' +
                                /*'<div class="form-group clearfix">' +
                                    '<input type="radio" value="1" class="form-control" name="rate_item_' + id + '_' + counter + '" />' +
                                '</div>' +*/

                            '</div>' +

                        '</div>' +
                    '</div>' +
                '</li>' +
                '<span class="error returnItemError" style="display:none;" id="return_item_error_' + id + '_' + counter + '"><i class="fa fa-times"></i><span class="errormessage"></span></span>'
            );

            bindElement($('#userPhoto_' + id + '_' + counter));

          	$('[name="reason_item_' + id + '_' + counter + '"]').on('change', function() {
              	var required = false;

              	if ($(this).find('option:selected').val() === 'Defective Product Received') {
                  	required = true;
              	}

              	$(this).closest('.row').find('.fn-requiredOptional').html(required ? '*' : '');
			});
        }
    }

    function setReturnProducts() {
        var counter;
        var orderProductsLength = window.order.data.line_items.length;

        window.order.returnProducts = [];

        window.order.data.line_items.forEach(function(lineItem) {
            for (counter = 0; counter < lineItem.availableQuantity; counter++) {
                if (
                    $('input:radio[name=radio_item_' + lineItem.id + '_' + counter + ']').length &&
                    $('input:radio[name=radio_item_' + lineItem.id + '_' + counter + ']:checked').val() !== 'None'
                ) {
                    window.order.returnProducts.push({
                        product: lineItem,
                        type: $('input:radio[name=radio_item_' + lineItem.id + '_' + counter + ']:checked').val()
                    });
                }
            }
        });
    }

    $(document).ready(function() {
        $('#continue2').on('click', function(e) {
            $('#products-shouldReturn').hide();

            setReturnProducts();

            if (window.order.returnProducts.length) {
                appendReturn();

                window.stepController.enableNextStep();
                window.stepController.goToStep(window.stepController.getActiveStep() + 1);
            } else {
                if ($('#productContainer li').length) {
                    $('#products-shouldReturn').fadeIn();
                }
            }
        });
    });
})(jQuery, window);